import type { IComponentController, IScope } from "angular";
import { filter, finalize, switchMap } from "rxjs/operators";

import type { IResponseWithLoading, ISearchResultByType, SearchResultType } from "App/Modules/Models";
import type { ISearchRepository } from "App/Modules/Repositories/Search/ISearchRepository";
import type { IModalService } from "App/Modules/Services";
import { Subject } from "rxjs";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

const RESULTS_PER_GROUP = 5;

export class SearchResultGroupComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmSearchRepository"];

    public searchResultByType: IResponseWithLoading<ISearchResultByType[]>;

    public isDetailedResults: boolean;

    public caption: string;

    public containerClasses: string;

    public searchString: string;

    public typingOffset: number;

    public type: SearchResultType;

    public count: number;

    public icon: string;

    public areNoResults: boolean;

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly searchRepository: ISearchRepository,
    ) {}

    public $onInit() {
        const typingSubject = new Subject<string>();

        typingSubject
            .pipe(
                filter((searchString) => searchString && searchString.length > this.typingOffset),
                switchMap((searchString) => {
                    this.areNoResults = false;

                    return extendWithLoadingAndFail(
                        this.searchRepository.search(
                            searchString,
                            this.type,
                            this.isDetailedResults ? null : RESULTS_PER_GROUP,
                        ),
                    ).pipe(
                        finalize(() => {
                            this.$scope.$applyAsync();
                        }),
                    );
                }),
            )
            .subscribe(
                (res: IResponseWithLoading<ISearchResultByType[]>) => {
                    this.searchResultByType = res;

                    if (this.searchResultByType.data && this.searchResultByType.data[0].results.length === 0) {
                        this.areNoResults = true;
                    }
                },
                (err: IResponseWithLoading<null>) => {
                    this.searchResultByType = err;
                },
            );

        this.$scope.$watch("$ctrl.searchString", (searchString: string) => {
            typingSubject.next(searchString);
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public openSearchDetails(type: SearchResultType) {
        this.modalService.open<string, { type: SearchResultType; caption: string; typingOffset: number }>(
            "irExtendedSearchDetails",
            this.searchString,
            {
                caption: this.caption,
                type: this.type,
                typingOffset: this.typingOffset,
            },
        );
    }
}
